import React from 'react';
import CollapsingList from './collapsing_list';
import SelectFacetOption from './select_facet_option';
import { filterID, FilterProps, WidgetType } from './search_filters';

const COLLAPSE_THRESHOLD = 7;

export default function SelectFacet({ filter, pageSection, trackingQuery }: FilterProps) {
  const labelId = `${pageSection}--${filterID(filter)}-lbl`;

  return (
    <div
      aria-labelledby={labelId}
      className="facet"
      role="group"
    >
      <div
        id={labelId}
        className="facet__heading"
      >
        {filter.name}
      </div>
      <CollapsingList
        countThreshold={filter.aggregationName === 'TRAITS' ? 3 : COLLAPSE_THRESHOLD}
      >
        {filter.options.map((option, idx) => (
          <SelectFacetOption
            key={idx}
            option={option}
            checkbox={filter.widgetType === WidgetType.CHECKBOX}
            trackingQuery={trackingQuery}
          />
        ))}
      </CollapsingList>
    </div>
  );
}
